import ButtonHandler from '../shared/product/button-handler';
import { SelectDropdownObserver } from '../shared/select-dropdown-v2';

export default class FlavorSelectDropdown {
  constructor(container, onChangeUI) {
    this.buttonHandler = new ButtonHandler();
    this.select = new SelectDropdownObserver(container, this.handleChange);
    this.onChangeUI = onChangeUI;
  }

  handleChange = (productId) => {
    this.onChangeUI(productId);
  };

  init = () => {
    this.select.init();
  };
}
